import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './slices/uiSlice';
import authReducer from './slices/authSlice';
import chartReducer from './slices/chartSlice';
import reportReducer from './slices/reportSlice';
import folderReducer from './slices/folderSlice';
import formReducer from './slices/formSlice';
import tabGroupReducer from './slices/tabGroupSlice';
import dashboardReducer from './slices/dashboardSlice';
import draftReducer from './slices/draftSlice';
import * as Sentry from '@sentry/react';
import { loggerMiddleware } from './middleware/loggerMiddleware';

export const store = configureStore({
    reducer: {
        ui: uiReducer,
        auth: authReducer,
        chart: chartReducer,
        report: reportReducer,
        folder: folderReducer,
        form: formReducer,
        tabGroup: tabGroupReducer,
        dashboard: dashboardReducer,
        draft: draftReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(loggerMiddleware),
    enhancers: (getDefaultEnhancers) =>
        getDefaultEnhancers().concat(Sentry.createReduxEnhancer()),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
